/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import api from "../../../Component/axios";

export const useDestino = () => {
  const token = localStorage.getItem("@Token");
  const [destino, setDestino] = useState([]);

  const getDestino = async () => {
    try {
      const response = await api.get("api/empaque/destino/?all=false", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + token,
        },
      });
      setDestino(response.data);
    } catch (error) {
      setDestino([]);
      console.log(error);
    }
  };

  useEffect(() => {
    getDestino();
  }, []);

  return { destino };
};
